import React from "react";
import { Link } from "react-router-dom";
import {
  LinearProgress,
  Box,
  styled,
  linearProgressClasses,
} from "@mui/material";
import { IoDocumentText } from "react-icons/io5";
import DataTable from "../../../../../components/Tables/DataTable";
import BreadCrumb from "../../../../../components/navbar/Breadcrumb";
import FiltrosComunidades from "../../../../../components/filtros/filtrosComunidades";
import { estadoServicio } from "../../../../../functions/funciones";

const BorderLinearProgress = styled(LinearProgress)((props) => ({
  height: 15,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#eee",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: props.value,
    backgroundColor:
      props.value < 25 ? "#FF5252" : props.value < 75 ? "#fcba03" : "#7bc977",
  },
}));

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={2}>
        <BorderLinearProgress {...props} variant="determinate" />
      </Box>
      <Box minWidth={35}>{`${Math.round(props.value * 100) / 100}%`}</Box>
    </Box>
  );
}

const ComunidadesOriginal = ({
  t,
  user,
  data,
  loading,
  fetchData,
  busqueda,
  filtrarDatos,
  clearFilters,
  busquedaActiva,
  setBusquedaActiva,
  clearFilterActivo,
  setClearFilterActivo,
  nif,
}) => {
  const comunidadesRows = [
    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('columns.community'),
      overrideFunc: (data, row) => (
        <Link to={`/comunidades/${row.nif}`}>{row.razonSocial}</Link>
      ),
    },
    ...(user.parent === true ? [{
      id: "aaff_razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('aaff:fields.office').toUpperCase(),
    }] : []),
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('columns.nif'),
    },
    {
      id: "codigoPostal",
      numeric: false,
      disablePadding: false,
      label: t('columns.postalCode'),
    },
    {
      id: "direccion",
      numeric: false,
      disablePadding: false,
      label: t('columns.address'),
    },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('columns.municipality'),
    },
    {
      id: "ultimaVisita",
      numeric: false,
      disablePadding: false,
      label: t('columns.visitSheet'),
    },
    {
      id: "estadoCae",
      numeric: false,
      disablePadding: false,
      label: t('columns.caeStatus'),
      overrideFunc: (data, row) =>
        !row.isWorkcenter ? (
          <div className="activoSelect">
            <span
              style={{
                color:
                  data === 1 || data == null
                    ? "#3eae3e"
                    : data === 2 || data === 3
                    ? "#FF8300"
                    : data === 4 || data === 5
                    ? "#EE4534"
                    : "#000",
              }}
            >
              {data === "-" ? data : estadoServicio(data, t)}
            </span>
          </div>
        ) : (
          ""
        ),
    },
    {
      id: "estadoLopd",
      numeric: false,
      disablePadding: false,
      label: t('columns.lopdStatus'),
      overrideFunc: (data, row) =>
        !row.isWorkcenter ? (
          <div className="activoSelect">
            <span
              style={{
                color:
                  data === 1 || data == null
                    ? "#3eae3e"
                    : data === 2 || data === 3
                    ? "#FF8300"
                    : data === 4 || data === 5
                    ? "#EE4534"
                    : "#000",
              }}
            >
              {data === "-" ? data : estadoServicio(data, t)}
            </span>
          </div>
        ) : (
          ""
        ),
    },
    {
      id: "estadoCai",
      numeric: false,
      disablePadding: false,
      label: t('columns.caiStatus'),
      overrideFunc: (data, row) =>
        !row.isWorkcenter ? (
          <div className="activoSelect">
            <span
              style={{
                color:
                  data === 1 || data == null
                    ? "#3eae3e"
                    : data === 2 || data === 3
                    ? "#FF8300"
                    : data === 4 || data === 5
                    ? "#EE4534"
                    : "#000",
              }}
            >
              {data === "-" ? data : estadoServicio(data, t)}
            </span>
          </div>
        ) : (
          ""
        ),
    },
    {
      id: "estadoKae",
      numeric: false,
      disablePadding: false,
      label: t('columns.kaeStatus'),
      overrideFunc: (data, row) =>
        !row.isWorkcenter ? (
          <div className="activoSelect">
            <span
              style={{
                color:
                  data === 1 || data == null
                    ? "#3eae3e"
                    : data === 2 || data === 3
                    ? "#FF8300"
                    : data === 4 || data === 5
                    ? "#EE4534"
                    : "#000",
              }}
            >
              {data === "-" ? data : estadoServicio(data, t)}
            </span>
          </div>
        ) : (
          ""
        ),
    },
    {
      id: "porcentajeDocs",
      numeric: false,
      disablePadding: false,
      label: t('columns.active'),
      noObjeto: true,
      overrideFunc: (data, row) => {
        return !row.isWorkcenter && row.estadoCae !== "-" ? (
          <LinearProgressWithLabel value={data} variant="determinate" />
        ) : (
          ""
        );
      },
    }
  ];

  return (
    <>
      <BreadCrumb
        rutas={[
          {
            path: `/aaff/${nif}/comunidades`,
            label: t('title'),
          },
        ]}
        style={{ margin: "0 10px" }}
      />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">{t('title').toUpperCase()}</div>
        </div>
      </div>
      <div className="pageContent tableContainer">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: 10,
            paddingRight: 10,
            marginTop: 20,
          }}
        >
          <div className="bigBtn">
            <Link
              to={`/doc-render/${user.nif}/situacion-comunidades`}
              target={"_blank"}
            >
              <IoDocumentText alt={t('aaff:reports.communityStatus')} />
              <span style={{ marginLeft: 15 }}>{t('aaff:reports.communityStatus')}</span>
            </Link>
          </div>
        </div>
        <FiltrosComunidades
          onFilter={filtrarDatos}
          clearFilter={clearFilters}
          filtrosIniciales={busqueda}
          serviceCounts={data.meta?.serviceCounts}
        />
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={comunidadesRows}
                fetcher={fetchData}
                currentPage={data.meta.current_page}
                meta={data.meta}
                totalItems={data.meta.total}
                totalPages={data.meta.totalPages}
                nextPage={data.meta.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('noCommunities')}
              />
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
};

export default ComunidadesOriginal;
